import React, { useState, useEffect } from 'react';
import CustomerService from '../../services/CustomerService';
import customerServices from '../../services/CustomerService';
import Lodder from "../../components/Lodder";
import { Table,  message } from "antd";

const SignedAgreement = () => {
    const [agreements, setAgreements] = useState([]);
    const [loading, setLoading] = useState(true);
      const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        fetchAgreements();
    }, []);

    const fetchAgreements = async () => {
        try {
            debugger;
            const response = await CustomerService.GetCustomerAgreements();
            const signedAgreements = response.resultData.filter(agreement => agreement.filePath.startsWith('KasperAgreements'));
            setAgreements(signedAgreements);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching agreements:', error);
            setLoading(false);
        }
    };

    const columns = [
        {
            title: "ID",
            render: (_, __, index) => index + 1,
            width: 50,
        },
        {
            title: 'Agreement Name',
            dataIndex: 'agreementName',
            key: 'agreementName',
        },
        {
            title: "Date Signed",
            dataIndex: "createdDate",
            key: "createdDate",
            sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
            render: (date) => {
                return (
                <>
                    {new Date(date).toLocaleDateString("en-US", {
                    day: "numeric",
                    month: "long",
                    year: "numeric",
                    })}
                </>
                );
            },
            width: 200,
        },
        {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="d-flex">
          <button
            className="submit-button"
            onClick={() => handleDownload(record.id)}
          >
            Download
          </button>
          {/* <button
            className="submit-button mx-3"
            onClick={() => handleView(record.id)}
          >
            View
          </button> */}
        </div>
      ),
      width: 120,
    },
    ];

//     const handleView = (id) => {
//     setShowLoader(true);
//     customerServices
//       .viewDocument(id)
//       .then((res) => {
//         if (res.resultData != null) {
//           window.open(`${res.resultData}`, "_blank");
//           message.success("File opened in new tab");
//         } else {
//           message.error("No file path received");
//         }
//       })
//       .catch(() => message.error("Error opening file"))
//       .finally(() => setShowLoader(false));
//   };

  const handleDownload = (id) => {
  setShowLoader(true);
  customerServices
    .viewDocument(id)
    .then((res) => {
      if (res.resultData != null) {
        const link = document.createElement("a");
        link.href = res.resultData;
        link.download = ""; // Optionally specify a filename here if you want
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        message.success("File download started");
      } else {
        message.error("No file path received");
      }
    })
    .catch(() => message.error("Error downloading file"))
    .finally(() => setShowLoader(false));
};


    return (
        <div className="content-wrapper">
             <Lodder show={showLoader} />
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 mt-5">
                            <div className="card border-0 shadow card-span w-100 mt-5">
                                <div className="card-header property-header py-3">
                                    <h5 className="mb-0 property-heading-card">
                                        SIGNED AGREEMENT
                                    </h5>
                                </div>
                                <div className="p-4 mt-2 table-responsive">
                                    <Table
                                        dataSource={agreements}
                                        columns={columns}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default SignedAgreement;